import { LoadingIndicator } from '../LoadingIndicator';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { jsx as _jsx } from "react/jsx-runtime";
export var InputLoadingIndicatorFullWidth = function InputLoadingIndicatorFullWidth() {
  var theme = useTheme();
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      width: '100%'
    },
    "data-element": "Box",
    "data-component": "InputLoadingIndicatorFullWidth",
    "data-source-file": "InputLoadingIndicator.tsx",
    children: /*#__PURE__*/_jsx(LoadingIndicator, {
      backgroundColor: theme.palette.gray[200],
      loadingStyle: "line-spinner",
      spinnerSize: 20,
      value: 20,
      "data-element": "LoadingIndicator",
      "data-source-file": "InputLoadingIndicator.tsx"
    })
  });
};
export var InputLoadingIndicator = function InputLoadingIndicator() {
  var theme = useTheme();
  return /*#__PURE__*/_jsx(LoadingIndicator, {
    backgroundColor: theme.palette.gray[200],
    loadingStyle: "line-spinner",
    spinnerSize: 20,
    value: 20,
    "data-element": "LoadingIndicator",
    "data-component": "InputLoadingIndicator",
    "data-source-file": "InputLoadingIndicator.tsx"
  });
};